<div class="ota-dashboard">
  
  <!-- Breadcrumb -->
    <div class="breadcrumb">
        <a [routerLink]="'/dashboard'">Home</a>
        <span class="separator">›</span>
        <span class="current">OTA</span>
    </div>

  <!-- Main Content -->
  <div class="main-content">
    <!-- Create Job Button -->
    <div class="top-action-bar">
      <button class="create-btn" (click)="createJob()">
        <img src="assets/plus-icon.svg" alt="logo">Create a Job
      </button>
    </div>

    <!-- Records Count and Search Section -->
    <div class="records-section">
      <div class="records-count">
        <strong>{{ totalRecords }}</strong> Records
      </div>

      <div class="search-section">
        <!-- Material Select Dropdown -->
        <mat-form-field class="filter-dropdown-container" appearance="outline">
          <mat-label>Search by</mat-label>
          <mat-select [(ngModel)]="selectedFilterValue" (selectionChange)="onFilterSelectionChange($event.value)"
            panelClass="mat-mdc-select-panel-custom">
            <mat-option *ngFor="let option of filterOptions" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="search-bar">
          <input matInput [(ngModel)]="searchQuery" placeholder="Type here" #headerInput="ngModel" appEnterKey
            (enterKey)="onSearch()">
          <button class="search-btn" (click)="onSearch()">
            <img src="assets/search-icon.svg" alt="Search">
          </button>
        </div>
      </div>
    </div>

    <!-- Filters -->
    <!-- <div class="filters-section" *ngIf="availableModels.length > 0">
      <span class="filter-label">Filters:</span>
      
      <button
        *ngFor="let model of availableModels"
        class="filter-btn"
        [class.active]="activeFilters[model]"
        (click)="toggleFilter(model)"
      >
        {{ model }}
        <span class="remove-icon" *ngIf="activeFilters[model]">×</span>
      </button>

      <a 
        href="#" 
        class="clear-all" 
        *ngIf="getActiveFiltersCount() > 0"
        (click)="clearAllFilters(); $event.preventDefault()"
      >
        Clear All
      </a>
    </div> -->

    <!-- Table -->
    <div class="table-container">
      <table class="jobs-table">
        <thead>
          <tr>
            <th>Job ID</th>
            <th>Job Name</th>
            <th>Model</th>
            <th>Created At</th>
            <th>Status</th>
            <th>Region</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let job of getPaginatedJobs()">
            <td>{{ job.id }}</td>
             <td><a class="job-link" (click)="openJobDetail(job)">{{ job.job_name }}</a></td>
            <td>{{ job.model }}</td>
            <td>{{ job.created_at | date:'yyyy-MM-dd HH:mm:ss'}}</td>
            <td>
              <span class="status-badge" [ngClass]="'status-' + job.status.toLowerCase().replace(' ', '-')">
                {{ formatStatus(job.status) }}
              </span>
            </td>
            <td>{{ job.regions }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="pagination-section">
      <span class="pagination-info">
        {{ startItem }}-{{ endItem }} of {{ totalPages }} pages
      </span>
      <div class="pagination">
        <button class="pagination-btn" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">
          ←
        </button>
        <button *ngFor="let page of getPageNumbers()" class="pagination-btn" [class.active]="page === currentPage"
          (click)="goToPage(page)">
          {{ page }}
        </button>
        <button class="pagination-btn" (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages">
          →
        </button>
      </div>
    </div>
  </div>
</div>